import React from 'react';
import {
  setPlanensAlderFilterToggled,
  setPlanAlderFilter,
} from '../../../store/actions';
import { connect } from 'react-redux';
import FilterSlider from './FilterSlider';
import SwatchBookIcon from '../../common/Icons/Light/SwatchBook';
import {
  IAppState,
  activeStyle as activeStyleEnum,
} from '../../../store/interfaces/state';
import { setActiveStyle as setActiveStyleAction } from '../../../store/actions';
import { neutral } from '../../../style/colors';

const PlanensAlder = (props: IPlanensAlderPropTypes) => {
  const {
    planAlderFilter,
    setPlanAlderFilter,
    toggled,
    setToggled,
    isActiveStyle,
    setActiveStyle,
    activeStyle,
  } = props;
  const className = isActiveStyle ? 'active-style' : '';
  const swatchBookIcon = (
    <SwatchBookIcon
      width={20}
      color={isActiveStyle ? neutral[600] : neutral[300]}
    />
  );
  return (
    <FilterSlider
      className={className}
      title={'Planens alder'}
      icon={swatchBookIcon}
      iconToggled={activeStyle === activeStyleEnum.planensAlder}
      onValueChange={vals => setPlanAlderFilter(vals)}
      valueDenomination={''}
      values={planAlderFilter}
      minValue={1970}
      maxValue={new Date().getFullYear()}
      toggled={toggled}
      setToggled={setToggled}
      onIconClick={() => setActiveStyle(activeStyleEnum.planensAlder)}
    />
  );
};

const mapStateToProps = (state: IAppState) => {
  return {
    toggled: state.filterToggled.planensAlder,
    planAlderFilter: state.filters.planensAlder,
    isActiveStyle: state.style.activeStyle === activeStyleEnum.planensAlder,
    activeStyle: state.style.activeStyle,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToggled: toggled => {
      dispatch(setPlanensAlderFilterToggled(toggled));
    },
    setPlanAlderFilter: planAlderFilter => {
      dispatch(setPlanAlderFilter(planAlderFilter));
    },
    setActiveStyle: style => {
      dispatch(setActiveStyleAction(style));
    },
  };
};

interface IPlanensAlderPropTypes {
  planAlderFilter: Array<number>;
  setPlanAlderFilter: Function;
  setToggled: Function;
  toggled: boolean;
  isActiveStyle: boolean;
  setActiveStyle: Function;
  activeStyle: string;
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanensAlder);
